var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "bubble-actions" }, [
    _c("div", { staticClass: "page-header" }, [
      _c("div", { staticClass: "title" }, [
        _vm._v(_vm._s(_vm.$t("message.bubbleOpenableMenu"))),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "subtitle" }, [
        _vm._v(
          "\n            " +
            _vm._s(_vm.$t("settings.bubbleActionsSubtitles")) +
            "\n        "
        ),
      ]),
    ]),
    _vm._v(" "),
    _c(
      "section",
      [
        _c("div", { staticClass: "fields" }, [
          _c(
            "div",
            { staticClass: "header-fields" },
            [
              _c("FeatureItem", {
                staticStyle: { width: "100%" },
                attrs: {
                  title: _vm.$t("message.isAlwaysActive"),
                  description: _vm.$t("message.isAlwaysActiveDesc"),
                  icon: "fab-menu",
                },
                model: {
                  value: _vm.isAlwaysActive,
                  callback: function ($$v) {
                    _vm.isAlwaysActive = $$v
                  },
                  expression: "isAlwaysActive",
                },
              }),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "header-fields" },
            [
              _c("FeatureItem", {
                attrs: {
                  title: _vm.$t("message.isFabsActive"),
                  description: _vm.$t("message.vtippyIsFabsActive"),
                  icon: "DropdownMenuIcon",
                },
                model: {
                  value: _vm.isFabsActive,
                  callback: function ($$v) {
                    _vm.isFabsActive = $$v
                  },
                  expression: "isFabsActive",
                },
              }),
              _vm._v(" "),
              _c("FeatureItem", {
                attrs: {
                  title: _vm.$t("settings.isFabsAsIcon"),
                  description: _vm.$t("message.vtippyIsFabsAsIcon"),
                  icon: "AddIcon",
                },
                model: {
                  value: _vm.isFabsAsIcon,
                  callback: function ($$v) {
                    _vm.isFabsAsIcon = $$v
                  },
                  expression: "isFabsAsIcon",
                },
              }),
            ],
            1
          ),
        ]),
        _vm._v(" "),
        _c("a-divider"),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "fab-content" },
          [
            _c("FabEditor", {
              attrs: { "update-settings": _vm.updateSettings },
            }),
          ],
          1
        ),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }